// data/classifieds.js

export const featuredAds = [
  {
    id: 1,
    title: 'Premium Electrician Services Ltd',
    description: '24/7 expert electrical repairs and installations in Mangalore.',
    contact: '98#####210',
  },
  {
    id: 2,
    title: 'Luxury Apartment for Rent',
    description: '2BHK fully furnished, sea view, Bondel area.',
    contact: '98#####240',
  },
  {
    id: 3,
    title: 'Event Decorators - Special Offer',
    description: 'Book now for festive discounts on party and wedding decor.',
    contact: '98#####231',
  },
  {
    id: 4,
    title: 'Used Car for Sale',
    description: '2018 Maruti Swift, single owner, excellent condition, Mangalore.',
    contact: '98#####555',
  },
  {
    id: 5,
    title: 'Home Tutor Available',
    description: 'Experienced tutor for Maths and Science, classes 6-10, Kankanady.',
    contact: '98#####888',
  },
];
